import React from 'react';

import styles from './styles.module.scss';

export interface ISubHeading {
  description?: string;
  icon?: React.ReactNode;
}

const SubHeading = ({ description, icon }: ISubHeading) => {
  return (
    <div className={styles.container}>
      {icon && icon}
      {description && <p>{description}</p>}
    </div>
  );
};

export default SubHeading;
